export default __webpack_public_path__ + "static/media/icon_harga_tertinggi.6c662959.svg";